export const ellipsisDocumentOptions = [
  { label: 'View', value: 'edit', callback: 'onRowView' },
  { label: 'Delete', value: 'delete', callback: 'onRowDelete' }
];
